import React from 'react';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import AppleIcon from '@mui/icons-material/Apple';
import { Grid } from '@mui/material';

function FooterIcetex() {
    return (
        <>
            <div className="crmware-previsora-footer-background footer-crmware-previsora">
                <div className="container-footer">
                    <div className="border-footer">
                        <div className="container">
                            <Grid container columns={{ xs: 1, sm: 12, md: 12 }}>
                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={6}
                                    className="footer-title content-footer"
                                >
                                    ICETEX
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <img
                                        className="govco-logo-entidad"
                                        alt="ICETEX Logo"
                                    />
                                </Grid>
                            </Grid>
                        </div>
                        <div className="container py-2">
                            <Grid container>
                                <Grid item xs={6} className="footer-detail">
                                    <p>
                                        <strong>
                                            Dirección sede principal:
                                        </strong>
                                        <br />
                                        Carrera. 3 No.18-32
                                        <br />
                                        CUNDINAMARCA - BOGOTÁ
                                        <br />
                                        Código postal: 111711
                                    </p>
                                    <p>
                                        <strong>Horario de atención:</strong>
                                        <br />
                                        Sede administrativa: Lunes a viernes de
                                        7:30 a.m. a 5:30 p.m.
                                        <br />
                                        Consulta los horarios de nuestros
                                        Centros de Experiencia Presencial a
                                        nivel nacional.
                                    </p>
                                    <p>
                                        <strong>Chat:</strong>
                                        24 horas todos los días.
                                    </p>
                                    <p>
                                        <strong>Redes sociales: </strong>
                                        (Twitter - Facebook) 24 horas todos los
                                        días.
                                    </p>
                                    <p>
                                        <strong>WhatsApp:</strong>
                                        Lunes a Viernes 07:00 a.m. a 07:00 p.m.
                                        Sábados de 08:00 a.m. a 04:00 p.m.
                                    </p>
                                    <p>
                                        <strong>Video atención:</strong>
                                        24 horas todos los días.
                                    </p>
                                    <p>
                                        <strong>
                                            Video atención lenguaje de señas:{' '}
                                        </strong>
                                        De lunes a viernes 8:00 a.m. a 6:00 p.m.
                                    </p>
                                    <p>
                                        <strong>Call Center: </strong>
                                        +57 333 6025656 (Lunes a viernes de 7:00
                                        a.m. a 7:00 p.m.). Sábados de 8:00 a.m.
                                        a 4:00 p.m.
                                    </p>
                                    <p>
                                        <strong>
                                            Linea Nacional (gratuita):
                                        </strong>
                                        018000-916821. Lunes a viernes de 7:00
                                        a.m. a 7:00 p.m y sábados de 8:00 a.m. a
                                        4:00 p.m.
                                    </p>
                                    <p>
                                        <strong>PBX: </strong>
                                        +57 (601) 382-1670
                                    </p>
                                    <p>
                                        <strong>
                                            Peticiones, quejas, reclamos,
                                            sugerencias y denuncias:
                                        </strong>
                                        &nbsp;
                                        <a
                                            target="_blank"
                                            title="Nueva ventana formulario de ventana digital PQRSD"
                                            href="https://web.crmware-previsora.gov.co/web/portal/atencion-al-ciudadano/canales-digitales/ventana-digital"
                                        >
                                            Ventana Digital
                                        </a>
                                    </p>
                                    <p>
                                        <strong>
                                            Radicación de Comunicaciones
                                            Oficiales:
                                        </strong>
                                        <a
                                            title="enlace para escribir correo a tutramite@crmware-previsora.gov.co"
                                            href="mailto:tutramite@crmware-previsora.gov.co"
                                        >
                                            tutramite@crmware-previsora.gov.co
                                        </a>
                                    </p>
                                    <p>
                                        <strong>
                                            Correo de notificaciones judiciales:
                                        </strong>
                                        &nbsp;
                                        <a
                                            title="enlace para escribir correo a notificaciones@crmware-previsora.gov.co"
                                            href="mailto:notificaciones@crmware-previsora.gov.co"
                                        >
                                            notificaciones@crmware-previsora.gov.co
                                        </a>
                                    </p>
                                    <p>
                                        <strong>
                                            Denuncias por actos de corrupción:{' '}
                                        </strong>
                                        <a
                                            title="enlace para escribir correo a soytransparente@crmware-previsora.gov.co"
                                            href="mailto:soytransparente@crmware-previsora.gov.co"
                                        >
                                            soytransparente@crmware-previsora.gov.co
                                        </a>
                                    </p>
                                </Grid>
                            </Grid>
                        </div>
                        <div className="container">
                            <Grid container>
                                <Grid item xs>
                                    <a
                                        className="footer-link-redes"
                                        title="Haz click para ir a la pagina de Facebook del ICETEX"
                                        href="https://www.facebook.com/icetexcolombia"
                                        target="_blank"
                                    >
                                        <FacebookIcon className="logo-social-networks" />
                                        ICETEX COLOMBIA
                                    </a>
                                    <br />
                                    <a
                                        className="footer-link-redes"
                                        title="Haz click para ir a la pagina de Twitter del ICETEX"
                                        href="https://twitter.com/ICETEX"
                                        target="_blank"
                                    >
                                        <TwitterIcon className="logo-social-networks" />
                                        @ICETEX
                                    </a>
                                </Grid>
                                <Grid item xs>
                                    <a
                                        className="footer-link-redes"
                                        title="Haz click para ir a la pagina de Instagram del ICETEX"
                                        href="https://www.instagram.com/icetex_colombia/"
                                        target="_blank"
                                    >
                                        <InstagramIcon className="logo-social-networks" />
                                        ICETEX_Colombia
                                    </a>
                                    <br />
                                    <a
                                        className="footer-link-redes"
                                        title="Haz click para ir al canal de Youtube del ICETEX"
                                        href="https://www.youtube.com/channel/UCQdpH6wYGuf7z-v1EzIZiow"
                                        target="_blank"
                                    >
                                        <YouTubeIcon className="logo-social-networks" />
                                        ICETEX COLOMBIA
                                    </a>
                                </Grid>
                                <Grid item xs>
                                    <a
                                        className="footer-link-redes"
                                        title="Haz click para ir a la pagina de Linkedin del ICETEX"
                                        href="https://www.linkedin.com/company/crmware-previsora"
                                        target="_blank"
                                    >
                                        <LinkedInIcon className="logo-social-networks" />
                                        ICETEX
                                    </a>
                                    <br />
                                    <a
                                        className="footer-link-redes"
                                        title="Haz click para ir a la pagina de Tiktok del ICETEX"
                                        href="https://www.tiktok.com/@icetex_oficial"
                                        target="_blank"
                                    >
                                        <img
                                            className="logo-social-networks tiktok-logo"
                                            alt="TikTok Logo"
                                        />
                                        ICETEX_oficial
                                    </a>
                                </Grid>
                                <Grid item xs>
                                    <a
                                        className="footer-link-redes"
                                        title="Haz click para ir a la pagina centro de relevo "
                                        href="https://centroderelevo.gov.co/632/w3-channel.html"
                                        target="_blank"
                                    >
                                        <img
                                            className="logo-social-networks centro-relevo-logo"
                                            alt="Centro de Relevo Logo"
                                        />
                                        Centro de Relevo
                                    </a>
                                    <br />
                                    <a
                                        className="footer-link-redes"
                                        title="Haz click para ir a la pagina Spotify"
                                        href="https://open.spotify.com/show/5r9DkXo4DomKrsMPW2ug7r"
                                        target="_blank"
                                    >
                                        <img
                                            className="logo-social-networks spotify-logo"
                                            alt="Spotify Logo"
                                        />
                                        Spotify
                                    </a>
                                    <br />
                                </Grid>
                                <Grid item xs>
                                    <a
                                        className="footer-link-redes"
                                        title="Haz click para ir a la pagina Apple Podcast"
                                        href="https://podcasts.apple.com/us/podcast/el-parche-de-crmware-previsora/id1658406205"
                                        target="_blank"
                                    >
                                        <AppleIcon className="logo-social-networks" />
                                        Apple
                                    </a>
                                </Grid>
                            </Grid>
                        </div>
                        <div className="crmware-previsora-container-links">
                            <Grid container>
                                <Grid
                                    item
                                    xs
                                    className="mx-auto footer-link-politicas py-3"
                                >
                                    <a
                                        href="/el-crmware-previsora/biblioteca/politicas-lineamientos-y-manuales"
                                        title="Ir a la sección políticas"
                                        target="_blank"
                                    >
                                        Políticas
                                    </a>
                                    <a
                                        href="/atencion-al-ciudadano/centros-de-experiencia-presencial-cep"
                                        title="ir a red de oficinas"
                                        target="_blank"
                                    >
                                        Red de oficinas
                                    </a>
                                    <a
                                        href="/atencion-al-ciudadano/centros-de-experiencia-presencial-cep"
                                        title="ir a Canales de atención"
                                        target="_blank"
                                    >
                                        Canales de atención
                                    </a>
                                    <a
                                        href="/terminos-y-condiciones-del-sitio"
                                        title="ir a  terminos y condiciones del sitio"
                                        target="_blank"
                                    >
                                        Términos y condiciones
                                    </a>
                                    <a
                                        href="/mapa-del-sitio"
                                        title="ir al mapa del sitio"
                                        target="_blank"
                                    >
                                        Mapa del sitio
                                    </a>
                                    <a
                                        href="http://becas/funcionarios/funcionarios.html"
                                        title="ir a funcionarios"
                                        target="_blank"
                                    >
                                        Funcionarios
                                    </a>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </div>
                <div className="govco-footer-logo">
                    <div className="govco-logo-container">
                        <span className="govco-co"></span>
                        <span className="govco-separator"></span>
                        <span className="govco-logo"></span>
                    </div>
                </div>
            </div>
        </>
    );
}

export default FooterIcetex;
